import React, { useEffect, useMemo, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Button, Card, Container, Group, Title, ActionIcon, Tooltip, Modal, Text } from '@mantine/core'; 
import { FaArrowLeft, FaEdit, FaTrash } from 'react-icons/fa'; 
import AddManagerForm from '../forms/AddManagerForm';
import {getManager,addManager,editManagers,deleteBranch} from '../../axios';

const Managers = () => {
  const [showForm, setShowForm] = useState(false);
  const [data, setData] = useState([]);
  const [editManager, setEditManager] = useState(false);
  const [update, setUpdate] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false); // State for dialog
  const [managerToDelete, setManagerToDelete] = useState(null); // State for manager to delete

  const handleAddManager = async(manager) => {
    if (editManager) {
      const res=await editManagers(manager)
      //console.log(res)
        if(res){
          setUpdate(!update);
          setShowForm(false);
          setEditManager(false); // Reset edit state
        }

    } else {
    const res=await addManager(manager)
  
         if(res){
          setUpdate(!update);
          setShowForm(false);
          setEditManager(false); // Reset edit state
         }
    }
  };

  const handleEdit = (row) => {
    setEditManager(row.original);
    setShowForm(true);
  };

  const handleDelete = (row) => {
    // Set manager to delete and open confirmation dialog
    setManagerToDelete(row.original);
    setConfirmDelete(true);
  };

  const confirmDeleteManager = async() => {
    if (managerToDelete) {
    const res= await deleteBranch(managerToDelete.id)

      if(res){
        setUpdate(!update); // Toggle update state to refresh data
        setConfirmDelete(false); // Close the dialog
      }
      else{
        console.error('Error deleting manager'); // Log the error
        setConfirmDelete(false); // Close the dialog even on error
      };
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'serialNumber',
        header: 'No.',
        Cell: ({ row }) => row.index + 1,
        size:60
      },
      {
        accessorKey: 'name',
        header: 'Manager Name',
      },
      {
        accessorKey: 'email',
        header: 'Email',
      },
      {
        accessorKey: 'contact',
        header: 'Contact',
      },
      {
        accessorKey: 'admin_name',
        header: 'Admin Name',
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        Cell: ({ row }) => (
          <Group spacing="sm">
            <Tooltip label="Edit Manager">
              <ActionIcon color="green" onClick={() => handleEdit(row)}>
                <FaEdit size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Delete Manager">
              <ActionIcon color="red" onClick={() => handleDelete(row)}>
                <FaTrash size={16} />
              </ActionIcon>
            </Tooltip>
          </Group>
        ),
      },
    ],
    []
  );

  useEffect(() => {
   const getData=async()=>{
    const res=await getManager();
    setData(res.data)
    //console.log(res)
   }
   getData()
  }, [update]);

  const table = useMantineReactTable({
    columns,
    data,
  });

  return (
    <Container size="lg" style={{ marginTop: '20px', padding: '20px' }}>
      {showForm ? (
        <>
          <Group position="left" mb="md">
             <ActionIcon variant="outline" color="gray" onClick={() => setShowForm(false)}>
                          <FaArrowLeft size={16} />
                        </ActionIcon>
          </Group>
          <AddManagerForm
            onSubmit={handleAddManager}
            editManager={editManager}
          />
        </>
      ) : (
        <>
          <Group position="apart" mb="md">
          <Title order={2} style={{ color: '#2c7a3b' }}>Manager List</Title>
            <Button variant="outline" color="green" onClick={() => setShowForm(true)}>
              Add Manager
            </Button>
          </Group>
          <Card shadow="sm" padding="lg" radius="md" withBorder>
            <MantineReactTable table={table} />
          </Card>
        </>
      )}

      {/* Confirmation modal for deletion */}
      <Modal
        opened={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        centered
        size="sm"
        overlayOpacity={0.55}
        overlayProps={{ blur: 4 }}
        title="Confirm Deletion"
      >
        <Text>Do you want to delete {managerToDelete ? managerToDelete.name : ''}?</Text>
        <Group position="right" mt="md">
          <Button variant="outline" onClick={() => setConfirmDelete(false)}>Cancel</Button>
          <Button color="red" onClick={confirmDeleteManager}>Confirm</Button>
        </Group>
      </Modal>
    </Container>
  );
};

export default Managers;
